import React from 'react';
import { currencyToCents } from '../../../utils/formatNumber';
import { InputAdornment, TextField } from '@mui/material';
import i18n from '../../../i18n';

export default class AmountInput extends React.Component {
    constructor(props) {
        super(props);
        const initial =
            props.value !== null && props.value !== undefined
                ? props.value / 100
                : '';
        this.state = {
            inputValue: initial,
            internalValue: props.value,
            error: false
        };
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.value !== prevState.internalValue) {
            return {
                inputValue:
                    nextProps.value !== null && nextProps.value !== undefined
                        ? nextProps.value / 100
                        : '',
                internalValue: nextProps.value,
                error: false
            };
        }
        return null;
    }

    validateAndFormat = (raw) => {
        const rawStr = String(raw);
        const cleaned = rawStr.replace(',', '.').trim();
        const valid = /^-?\d*(\.\d{0,2})?$/.test(cleaned);

        if (!valid) return { isValid: false };

        const parsed = Number(cleaned);
        if (isNaN(parsed)) return { isValid: false };

        return { isValid: true, parsed, formatted: cleaned };
    };

    handleChange = (e) => {
        const raw = e.target.value;
        const result = this.validateAndFormat(raw);

        this.setState({
            inputValue: raw,
            error: !result.isValid
        });

        if (result.isValid) {
            const cents = currencyToCents(result.parsed);
            this.props.onChange(this.props.id, cents);
        }
    };

    handleBlur = () => {
        const { inputValue } = this.state;
        const result = this.validateAndFormat(inputValue);

        if (result.isValid) {
            this.setState({
                inputValue: result.parsed.toFixed(2),
                internalValue: currencyToCents(result.parsed),
                error: false
            });
        } else {
            this.setState({ error: true });
        }
    };

    render() {
        const { id, label, currencySymbol } = this.props;
        const { inputValue, error } = this.state;

        return (
            <TextField
                key={id}
                margin="dense"
                id={id}
                label={label}
                placeholder="0.00"
                value={inputValue}
                fullWidth
                error={error}
                helperText={error && i18n.t('errors.invalidNumber')}
                onChange={this.handleChange}
                onBlur={this.handleBlur}
                onFocus={(e) => e.target.select()}
                InputProps={{
                    startAdornment: currencySymbol ? (
                        <InputAdornment position="start">
                            {currencySymbol}
                        </InputAdornment>
                    ) : null,
                    inputMode: 'decimal'
                }}
            />
        );
    }
}
